import { configFacts } from '../lib/supabase'
import { useI18n } from '../i18n/useI18n'

/**
 * Panneau replie, disponible sur l'ecran de connexion, montrant la
 * configuration reellement embarquee dans le site publie.
 *
 * Les valeurs sont saisies dans le tableau de bord Netlify puis figees
 * dans le JavaScript a la construction : quand elles sont fausses, le
 * seul symptome est une erreur du serveur qui ne dit rien de sa cause.
 * Ceci permet de lire la cause depuis le telephone, a Mbour comme a
 * Montreal, sans outil de developpement.
 */
export function ConfigDiagnostic() {
  const { t } = useI18n()
  const f = configFacts

  return (
    <details className="diag">
      <summary className="diag__summary">{t('diag_title')}</summary>

      <dl className="diag__list">
        <dt>{t('diag_url')}</dt>
        <dd><code>{f.urlInUse}</code></dd>

        <dt>{t('diag_key')}</dt>
        <dd>
          <code>
            {f.keyHead}…{f.keyTail}
          </code>{' '}
          {t('diag_key_length', { n: f.keyLength })}
        </dd>

        <dt>{t('diag_project_key')}</dt>
        <dd><code>{f.keyRef}</code></dd>

        <dt>{t('diag_project_url')}</dt>
        <dd><code>{f.urlRef}</code></dd>
      </dl>

      {/* Le fait le plus revelateur en premier, en clair. */}
      <p className={`diag__verdict ${f.refsMatch ? 'is-ok' : 'is-bad'}`}>
        {f.refsMatch ? t('diag_match_ok') : t('diag_match_bad')}
      </p>

      {f.keyWasCleaned && <p className="diag__warn">{t('diag_key_cleaned')}</p>}
      {f.urlWasCorrected && <p className="diag__warn">{t('diag_url_corrected')}</p>}
    </details>
  )
}
